import 'swiper/css'
import 'swiper/css/effect-creative'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import { ReactNode } from 'react'
import styled, { RuleSet } from 'styled-components'
import { Autoplay, EffectCreative, Pagination } from 'swiper/modules'
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react'
import type { Swiper as SwiperClass } from 'swiper/types'

interface SwiperPropsType {
  children: ReactNode
  $wrapstyle?: RuleSet<object>
  onActiveIndexChangeFn?: (activeIdx: number) => void
  type: 'creative' | 'default'
  gap?: number
  swiperOption?: SwiperProps
  onSwiper?: (swiper: SwiperClass) => void
}
/* eslint-disable react-refresh/only-export-components */
const CustomSwiperWrap = ({
  gap,
  onActiveIndexChangeFn,
  swiperOption,
  type,
  children,
  $wrapstyle,
  onSwiper,
}: SwiperPropsType) => {
  const swiperOptions: { [key: string]: SwiperProps } = {
    default: {
      grabCursor: true,
      slidesPerView: 'auto',
      onActiveIndexChange: (swiper: SwiperClass) => onActiveIndexChangeFn?.(swiper.activeIndex),
      spaceBetween: gap as number,
      modules: [Pagination, Autoplay],
      pagination: { type: 'fraction' },
      onSwiper,
      ...swiperOption,
    },
    creative: {
      grabCursor: true,
      effect: 'creative',
      slidesPerView: 'auto',
      centeredSlides: true,
      simulateTouch: true,
      pagination: { type: 'fraction' },
      creativeEffect: {
        prev: { shadow: true, translate: ['-2%', '-0.5%', 0] },
        next: { shadow: true, translate: ['103%', 0, 0] },
      },
      modules: [EffectCreative, Pagination],
      onActiveIndexChange: (swiper: SwiperClass) => onActiveIndexChangeFn?.(swiper.activeIndex),
    },
  }
  return (
    <SwiperContainer {...swiperOptions[type]} $wrapstyle={$wrapstyle}>
      {children}
    </SwiperContainer>
  )
}

const SwiperContainer = styled(Swiper)<{ $wrapstyle?: RuleSet<object> }>`
  ${(props) => props.$wrapstyle};
`
const SwiperItemsWrap = styled(SwiperSlide)<{ $itemstyle?: RuleSet<object> }>`
  width: fit-content;
  ${(props) => props.$itemstyle};
`

export const CustomSwiper = {
  Wrap: CustomSwiperWrap,
  Item: SwiperItemsWrap,
}
